
import {gql} from '@apollo/client';
import {useQuery} from '@apollo/client/react';
import { useAuthContext } from '@/context/AuthContext';
import {useAppSelector} from '@/store/hooks.js';

// Définition de la requête GraphQL pour obtenir tous les profils de consultants
const GET_ALL_CONSULTANT_PROFILES = gql`
  query ALL_CONSULTANT_PROFILES($companyUuid: ID!) {
    allConsultantProfiles(companyUuid: $companyUuid) {
      name
      uuid
    }
  }
`;

const useAllConsultantProfiles = (options = {}) => {
  const { skip = false } = options;
  const user = useAppSelector((state) => state.auth.currentUser);
  const companyUuid = user?.company?.uuid;

  const { loading, error, data, refetch } = useQuery(GET_ALL_CONSULTANT_PROFILES, {
    variables: { companyUuid },
    fetchPolicy: "network-only",
    skip: skip || !companyUuid,
  });

  return {
    loading,
    error,
    consultantProfiles: data?.allConsultantProfiles,
    refetch
  };
};

export default useAllConsultantProfiles;
